import { Injectable } from '@angular/core';
import { AsyncStore } from '@cawita/core-front/state';
import { Socket } from 'ngx-socket-io';
import { finalize, map, switchMap, tap } from 'rxjs/operators';
import { HiddenNotifications, NotificationCheck } from '../../../../../frontend-shared/src/lib/models';
import { NotificationAPI } from './notification.api';

export interface NotificationState {
    check: NotificationCheck;
    count: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationStore extends AsyncStore<NotificationState> {

    constructor(
        private notificationApi: NotificationAPI,
        private socket: Socket
    ) {
        super({
            check: null,
            count: null
        });
    }

    public init() {
        this.setInitialized(false);
        this.setLoading(true);
        this.socket.removeListener('notification', this._onNotification)
        return this.getCheckAndCount().pipe(
            finalize(() => {
                this.setLoading(false);
                this.setInitialized(true);
            }),
            tap(res => this.setState(c => ({
                ...c,
                check: res.check,
                count: res.count
            }))),
            tap(() => this.socket.on('notification', this._onNotification))
        );
    }

    public check() {
        this.setState(c => ({ ...c, count: 0 }));
        return this.notificationApi.createCheck().pipe(
            tap(res => this.setState(c => ({
                ...c,
                check: res,
                count: 0
            })))
        );
    }

    private getCheckAndCount() {
        return this.notificationApi.getLastCheck().pipe(
            switchMap((check) => this.notificationApi.countFromCheck(check).pipe(
                map(count => ({ check, count }))
            ))
        );
    }

    private _onNotification = (notification: any) => {
        if (HiddenNotifications.includes(notification?.type)) return;
        this.setState(c => ({ ...c, count: (c.count ?? 0) + 1 }));
    }
}